import React,{Component} from 'react';
import { IonRouterLink, IonLoading } from '@ionic/react';

import './Register.css';
// import classNames from 'classnames';

// Redux
import { connect } from 'react-redux';
import Page from '@acri-tools/react-tools/components/Page/Page';
import { homeBanner, logo } from '../../theme/images';
import routes from '../../utils/routes';
import Message from '@acri-tools/react-tools/components/Message/Message';
import { axiosErrorHandler, go_back, push_history } from '@acri-tools/react-tools/utils/global';
import { login } from '@acri-tools/react-tools/utils/login';
import { setLogin } from '@acri-tools/react-tools/redux/actions';
import { create_toast } from '@acri-tools/react-tools/utils/toasts';
import request from '@acri-tools/react-tools/utils/request';
import { API_URL } from '../../utils/config';
import Footer from '../../components/Footer/Footer';

// components
// methods
interface Props{
    // REDUX
}

class Register extends Component<Props,{}>{
    state={
        loading: false,

        email: '',
        username: '',
        first_name: '',
        last_name: '',
        password: '',
        confirm_password: '',

        hasEntered: false,
        message: '',
        messageType: 'error'
    }
    render(){
        return (
            <Page 
                id="register"
                footer={<Footer />}
                topBar={{
                    logo: logo,
                    routes: routes,
                }}
            >
                <IonLoading
                    isOpen={this.state.loading}
                    message={'Registering...'}
                />
                <div 
                    className="page-content"
                    style={{
                        backgroundImage:`url(${homeBanner})`
                    }}
                >
                    <div id="login-container" className="form-container">
                        <div className="form">
                            <div className="form-field large">
                                <label>
                                    Email
                                </label>
                                <input 
                                    type="email" value={this.state.email} placeholder={"Email"}
                                    onKeyDown={this.onEnter} onChange={(e)=>{ this.inputTyped(); this.setState({ email: e.target.value }); }}/>
                            </div>
                            <div className="form-field large">
                                <label>
                                    Username
                                </label>
                                <input 
                                    type="text" value={this.state.username} placeholder={"Username"}
                                    onKeyDown={this.onEnter} onChange={(e)=>{ this.inputTyped(); this.setState({ username: e.target.value }); }}/>
                            </div>
                            <div className="row-2">
                                <div className="form-field large">
                                    <label>
                                        First Name
                                    </label>
                                    <input 
                                        type="text" value={this.state.first_name} placeholder={"First name"}
                                        onKeyDown={this.onEnter} onChange={(e)=>{ this.inputTyped(); this.setState({ first_name: e.target.value }); }}/>
                                </div>
                                <div className="form-field large">
                                    <label>
                                        Last Name
                                    </label>
                                    <input 
                                        type="text" value={this.state.last_name} placeholder={"Last name"}
                                        onKeyDown={this.onEnter} onChange={(e)=>{ this.inputTyped(); this.setState({ last_name: e.target.value }); }}/>
                                </div>
                            </div>
                            <div className="form-field large">
                                <label>
                                    Password
                                </label>
                                <input 
                                    type="password" value={this.state.password}  placeholder={"Password"}
                                    onKeyDown={this.onEnter} onChange={(e)=>{ this.inputTyped(); this.setState({password:e.target.value}); }}/>
                            </div>
                            <div className="form-field large">
                                <label>
                                    Confirm Password
                                </label>
                                <input 
                                    type="password" value={this.state.confirm_password}  placeholder={"Confirm password"}
                                    onKeyDown={this.onEnter} onChange={(e)=>{ this.inputTyped(); this.setState({ confirm_password:e.target.value}); }}/>
                            </div>
                            
                            <Message message={ this.state.message } type={ this.state.messageType }/>
                            
                        </div>



                        <div className="custom-button register" onClick={this.register}>REGISTER</div>
                        <h2 className="divider"><div className="line"/><span>OR</span><div className="line"/></h2>
                        <div className="custom-button login" onClick={()=>{ push_history('/login') }}>LOGIN</div>
                    </div>  
                </div>
            </Page>
        );
    }

    inputTyped = () =>{
        this.setState({
            message: ''
        })
    }
    onEnter = (e:any) =>{
        if(e.keyCode === 13){
            this.register();
        }
    }
    register = async() =>{
        for(
            let attribute of [
                'email',
                'username',
                'first_name',
                'last_name',
                'password',
                'confirm_password'
            ]
        ){
            let state:any = this.state;
            if(!state[attribute]){
                let displayed_attribute:string = attribute.replace('_', ' ');
                displayed_attribute = `${displayed_attribute[0].toUpperCase()}${displayed_attribute.substring(1)}`;
                return this.setState({
                    message: `Missing ${displayed_attribute}`,
                    messageType: 'warn'
                })
            }
        }
        if(this.state.password !== this.state.confirm_password){
            return this.setState({
                message: 'Passwords do not match.',
                messageType: 'warn'
            })
        }

        this.setState({ loading:true });
        try{
            let {
                email, username, first_name, last_name, password
            } = this.state;
            let res = await request(`${API_URL}/api/user-manager/v1/register`,{
                method: 'post',
                data:{
                    email, password, username,
                    firstname: first_name,
                    lastname: last_name,
                }
            });

            create_toast({ type: 'success', message: `Registration email sent to ${email}` })
            push_history('/login')
        }
        catch(e){
            this.setState({
                message: e.response && e.response.data && e.response.data.error  ? e.response.data.error : 'An error has occured.',
                messageType: 'error'
            })
            axiosErrorHandler( e, {
                functionName: 'register',
            })
        }
        finally{
            this.setState({ loading:false })
        }
        
    }
};

const mapStateToProps = (state:any) =>{
    return {
        login : state.login
    }
}

export default connect(mapStateToProps,{ })(Register);
